<template>
  <div id="content_box_id"
       class="content_box_cla">
    <div v-bind:style="leftStyle"
         :class="'left-item-cla '+leftClass">
      <slot name="left"></slot>
    </div>
    <div v-bind:style="rightStyle"
         :class="'right-item-cla '+rightClass">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'zkContent',
  mounted () {
    let height = document.getElementById('content_box_id').offsetHeight
    this.$emit('contentHeight', height)
  },
  computed: {},
  props: {
    leftStyle: {
      type: String,
      default: ''
    },
    rightStyle: {
      type: String,
      default: ''
    },
    leftClass: {
      type: String,
      default: ''
    },
    rightClass: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="less">
@import '~@/styles/var.less';
.content_box_cla {
  display: flex;
  width: 100%;
  height: 100%;
  .left-item-cla {
    position: relative;
    width: 60%;
    padding: 10px;
    background-color: @lightBgColor;
  }
  .right-item-cla {
    position: relative;
    margin-left: 15px;
    padding: 10px;
    flex-grow: 1;
    background-color: @lightBgColor;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/content.vue